import { useMemo } from 'react';
import { useQuery } from 'data-fetching-client';
import { userInfoSync } from 'hub-http/userInfo';
import { GET_TARGET_HUBS } from '../../shared/data';
import { captureException } from '../../utils/captureException';
export function useTargetHubs(options = {}) {
  const {
    portal
  } = userInfoSync();
  const {
    data,
    loading
  } = useQuery(GET_TARGET_HUBS, Object.assign({}, options, {
    onError: error => {
      var _options$onError;
      captureException(error, ['useTargetHubs']);
      (_options$onError = options.onError) === null || _options$onError === void 0 || _options$onError.call(options, error);
    }
  }));
  const filteredPortals = useMemo(() => {
    if (!data) {
      return [];
    }
    return data.targetHubs.hubs.filter(hub => hub.hubId !== portal.portal_id);
  }, [data, portal.portal_id]);
  const currentAccountName = useMemo(() => {
    if (!data) {
      return null;
    }
    const currentHub = data.targetHubs.hubs.find(hub => hub.hubId === portal.portal_id);
    return (currentHub === null || currentHub === void 0 ? void 0 : currentHub.name) || null;
  }, [data, portal.portal_id]);
  return {
    targetHubs: filteredPortals,
    currentAccountName,
    loading
  };
}